import React, { useEffect, useState, useCallback } from "react";
import { Modal, Table, Button, Input, message, Spin, Typography} from "antd";
import axios from "axios";
import 'antd/dist/reset.css';
import { endpoints } from './caminhoApi';

const ALERT_TYPES = ["Hunted", "Prioridade", "Bomba", "Maker", "Swap"];

export default function AlertasModal({ visible, onClose, fetchAlertConfig }) {
  const [alertas, setAlertas] = useState({});
  const [saving, setSaving] = useState(false);
  const [id, setId] = useState(sessionStorage.getItem('id') || '');
  const [senha, setSenha] = useState(sessionStorage.getItem('senha') || '');
  const [authenticated, setAuthenticated] = useState(false);
  const [autoAuthTried, setAutoAuthTried] = useState(false); // para não tentar autenticar toda hora

    const handleAuthentication = useCallback(async (auto = false) => {
    const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';

    if (storedAuthenticated) {
      setAuthenticated(true);
      return;
    }

    if (!id || !senha) {
      if (!auto) message.error("Preencha ID e senha!");
      return;
    }

    try {
      const response = await axios.post(endpoints.loginEndpoint, { id, senha });

      if (response.status === 200) {
        setAuthenticated(true);
        if (!auto) message.success("Autenticação bem-sucedida.");

        sessionStorage.setItem('authenticated', 'true');
        sessionStorage.setItem('id', id);
        sessionStorage.setItem('senha', senha);
      }
    } catch (error) {
      if (!auto) message.error("ID ou senha incorretos.");
    }
  }, [id, senha]); // depende apenas de id e senha

  useEffect(() => {
    if (visible && !authenticated && !autoAuthTried) {
      if (id && senha) {
        handleAuthentication(true); // Tenta autenticação automática
      }
      setAutoAuthTried(true);
    }
  }, [visible, authenticated, autoAuthTried, id, senha, handleAuthentication]);

  useEffect(() => {
    if (authenticated && visible) {
      fetchAlertas();
    }
  }, [authenticated, visible]);

  useEffect(() => {
    const storedAuthenticated = sessionStorage.getItem('authenticated') === 'true';
    
    if (storedAuthenticated) {
      setAuthenticated(true);
    } else if (id && senha) {
      handleAuthentication(true);
    }

    setAutoAuthTried(true);
  }, [visible, id, senha, handleAuthentication]);

  const handleClose = () => {
    onClose();
    setAuthenticated(false); // limpar autenticação ao fechar
    setAutoAuthTried(false);  // permitir nova tentativa ao abrir
    //window.location.reload();
  };

  const fetchAlertas = async () => {
    try {
      const res = await axios.get(endpoints.alertasEndpoint);
      setAlertas(res.data || {});
    } catch {
      message.error("Erro ao carregar alertas.");
    }
  };
  
  const handleSaveAlertas = async () => {
    setSaving(true);

    const alertasCompletos = {};

    ALERT_TYPES.forEach(type => {
      const alertaExistente = alertas[type] || {};

      alertasCompletos[type] = {
        minPlayers: Number(alertaExistente.minPlayers) || 5,
        maxMinutes: Number(alertaExistente.maxMinutes) || 5,
        repeat: Number(alertaExistente.repeat) || 1,
        sound: type === "Swap" ? "alert2.mp3" : "alert.mp3"
      };
    });

    try {
      await axios.post(endpoints.alertasEndpoint, alertasCompletos);
      message.success("Alertas salvos com sucesso!");
      fetchAlertConfig();
    } catch (error) {
      console.error("Erro ao salvar alertas:", error);
      message.error("Erro ao salvar alertas.");
    } finally {
      setSaving(false);
    }
  };

  const handleChangeAlert = (type, key, value) => {
    setAlertas(prev => ({
      ...prev,
      [type]: {
        ...prev[type],
        [key]: value,
        sound: prev[type]?.sound || (type === "Swap" ? "alert2.mp3" : "alert.mp3"),
      },
    }));
  };

  const columns = [
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      align: "center",
      render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>,
    },
    {
      title: "Mín. Players",
      dataIndex: "minPlayers",
      key: "minPlayers",
      align: "center",
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => handleChangeAlert(record.type, "minPlayers", e.target.value)}
          size="small"
          style={{ width: 70, textAlign: "center" }}
        />
      ),
    },
    {
      title: "Máx. Minutos (login)",
      dataIndex: "maxMinutes",
      key: "maxMinutes",
      align: "center",
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => handleChangeAlert(record.type, "maxMinutes", e.target.value)}
          size="small"
          style={{ width: 70, textAlign: "center" }}
        />
      ),
    },
    {
      title: "Repetições",
      dataIndex: "repeat",
      key: "repeat",
      align: "center",
      render: (value, record) => (
        <Input
          value={value}
          onChange={(e) => handleChangeAlert(record.type, "repeat", e.target.value)}
          size="small"
          style={{ width: 70, textAlign: "center" }}
        />
      ),
    },
  ];

  const dataSource = ALERT_TYPES.map((type) => ({
    key: type,
    type,
    minPlayers: alertas[type]?.minPlayers || 5,
    maxMinutes: alertas[type]?.maxMinutes || 5,
    repeat: alertas[type]?.repeat || 1,
  }));

  return (
    <Modal
      title="Alert Settings"
      open={visible}
      onCancel={handleClose}
      width={600}
      footer={null}
      style={{ top: 50 }}
      styles={{
        body: {
          maxHeight: '75vh',
          overflowY: 'auto',
          padding: 15,
          borderRadius: 10,
        },
      }}
    >
	  
      {!authenticated ? (
        <div style={{ maxWidth: 300, margin: "auto" }}>
          <Input
            placeholder="ID"
            value={id}
            onChange={(e) => setId(e.target.value)}
            style={{ marginBottom: 8 }}
          />
          <Input.Password
            placeholder="Senha"
            value={senha}
            onChange={(e) => setSenha(e.target.value)}
            style={{ marginBottom: 8 }}
          />
          <Button type="primary" block onClick={() => handleAuthentication()}>
            Autenticar
          </Button>
        </div>
      ) : (
        <>
          {saving ? (
            <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
              <Spin size="large" />
            </div>
          ) : (
            <>
            {/* Explicação do Swap */}
            <div style={{ marginBottom: 20, fontSize: '14px' }}>
                <Typography.Paragraph>
                La alerta de <strong>Swap</strong> se activa cuando un número significativo de jugadores cambia de guilda en un intervalo de tiempo (login),
                sugiriendo un posible ataque coordinado. Esto ocurre si los <strong>Mín. Players</strong> disminuyen en una guilda y se conectan <strong>Mín. Players</strong> o más en la otra
                dentro del intervalo de <strong>Máx. Minutos (login)</strong>.
                </Typography.Paragraph>
            </div>
              <Table
                rowKey="key"
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                size="small"
                bordered
                style={{ marginBottom: 20 }}
              />
              <div style={{ display: "flex", justifyContent: "center", marginTop: 8 }}>
                <Button
                  type="primary"
                  loading={saving}
                  onClick={handleSaveAlertas}
                >
                  Save
                </Button>
              </div>
            </>
          )}
        </>
      )}
    </Modal>
  );
}